import { ActivityState } from '@/api/models/activity'
import { FrontActivityPart } from '@/store/slices/aggregateSlice/types/FrontActivityPart.type'
import { FrontActivityWithAggregate } from '@/store/slices/aggregateSlice/types/FrontActivityWithAggregate.type'
import { activityConstraintValidation } from './activityConstraintValidation'

export const isAvailable = (activityPart: FrontActivityPart<FrontActivityWithAggregate>) => {
  const activityState = activityPart.childActivity.state
  // Expired means that it's accessible by learner like a ready, but for the author it means, that it's not available to use at new courses
  const atReadyState = activityState === ActivityState.ready || activityState === ActivityState.expired

  return atReadyState && activityPart.available && !activityConstraintValidation(activityPart).disabled
}
